import http from "../http-common"

class ConvergenceCarouselService {
    getAllConvergenceCarousel() {
        return http.get("/banners/hero-primary")
    }
}


export default new ConvergenceCarouselService();